function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.83619 9.75804C6.39622 7.41506 6.94325 5.06807 7.52129 2.73008C7.90431 1.18409 8.53135 0.759093 10.0524 1.12109C13.1896 1.86909 16.3188 2.66408 19.443 3.47008C20.7701 3.81408 21.2191 4.56407 20.9031 5.90806C19.76 10.764 18.6009 15.614 17.4249 20.461C17.1138 21.741 16.3858 22.214 15.1277 21.912C11.8705 21.127 8.62135 20.31 5.37616 19.471C4.17109 19.159 3.79107 18.412 4.10509 17.037C4.66212 14.605 5.25816 12.184 5.83619 9.75804Z",
  fill: "#F5F500"
});

var SvgYellowcard = function SvgYellowcard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowcard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowcard.85fa87a6.svg";
export { ForwardRef as ReactComponent };